export enum MembershipPaymentMode {
    BankTransfer = 1,
    UPI = 2,
    Cash = 3,
  }
  